// src/main.jsx - ИСПРАВЛЕННАЯ ВЕРСИЯ С ОБРАБОТКОЙ НЕАКТИВНОГО АККАУНТА
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css'

// Глобальный обработчик ошибок для предотвращения краха приложения
const ErrorBoundary = ({ children }) => {
  React.useEffect(() => {
    const handleError = (event) => {
      console.error('Global error caught:', event.error);
      // Предотвращаем падение приложения
      event.preventDefault();
    };

    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      // Предотвращаем падение приложения
      event.preventDefault();
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return children;
};

// Глобальные стили для toast уведомлений
const addNotificationStyles = () => {
  const style = document.createElement('style');
  style.textContent = `
    .notification-toast {
      animation: slideInRight 0.3s ease-out;
    }
    
    @keyframes slideInRight {
      from {
        transform: translateX(100%);
        opacity: 0;
      }
      to {
        transform: translateX(0);
        opacity: 1;
      }
    }
    
    .notification-toast.fade-out {
      animation: slideOutRight 0.3s ease-in;
    }
    
    @keyframes slideOutRight {
      from {
        transform: translateX(0);
        opacity: 1;
      }
      to {
        transform: translateX(100%);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(style);
};

// Глобальный обработчик для предотвращения обновления страницы при ошибках форм
const handleFormErrors = () => {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.method === 'post') {
      // Для форм с методом POST предотвращаем стандартное поведение
      e.preventDefault();
    }
  });
};

// ✅ Функция проверки неактивного аккаунта при загрузке
// src/main.jsx - добавляем в функцию checkInactiveOnLoad
const checkInactiveOnLoad = () => {
  const currentPath = window.location.pathname;
  
  // Если уже на странице неактивного аккаунта, ничего не делаем
  if (currentPath === '/_admin/inactive') return;
  
  const inactiveReason = localStorage.getItem('inactive_reason');
  if (inactiveReason) {
    try {
      const reason = JSON.parse(inactiveReason);
      const timestamp = new Date(reason.timestamp);
      const now = new Date();
      
      // Если прошло больше 5 минут, очищаем
      if (now - timestamp > 5 * 60 * 1000) {
        console.log('🧹 Clearing expired inactive reason (older than 5 minutes)');
        localStorage.removeItem('inactive_reason');
        return;
      }
      
      console.log('🔴 Found inactive reason, but NOT redirecting automatically');
      // ✅ НЕ ДЕЛАЕМ РЕДИРЕКТ АВТОМАТИЧЕСКИ
      // Просто логируем, но не перенаправляем
    } catch {
      localStorage.removeItem('inactive_reason');
    }
  }
};


// ✅ Добавляем слушатель события деактивации аккаунта
const setupInactiveListener = () => {
  window.addEventListener('account_deactivated', (event) => {
    console.log('🔴 Account deactivated event received:', event.detail);
    
    // Сохраняем причину если её еще нет
    if (!localStorage.getItem('inactive_reason')) {
      localStorage.setItem('inactive_reason', JSON.stringify({
        message: event.detail?.message || 'Ваш аккаунт деактивирован',
        timestamp: new Date().toISOString(),
        source: 'global_event'
      }));
    }
    
    // Если не на странице неактивного аккаунта, редиректим
    if (window.location.pathname !== '/_admin/inactive') {
      window.location.href = '/_admin/inactive';
    }
  });

  
};



ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)

// Инициализация после рендера
setTimeout(() => {
  handleFormErrors();
  addNotificationStyles();
  checkInactiveOnLoad(); // ✅ Проверка неактивного аккаунта
  setupInactiveListener(); // ✅ Слушатель события деактивации
}, 100);